import { render, staticRenderFns } from "./simple-layout.vue?vue&type=template&id=517afd34&scoped=true&"
import script from "./simple-layout.vue?vue&type=script&lang=js&"
export * from "./simple-layout.vue?vue&type=script&lang=js&"
import style0 from "./simple-layout.vue?vue&type=style&index=0&id=517afd34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517afd34",
  null
  
)

export default component.exports